import { render, staticRenderFns } from "./StartPlaying.vue?vue&type=template&id=1e3777c1&scoped=true&"
import script from "./StartPlaying.vue?vue&type=script&lang=js&"
export * from "./StartPlaying.vue?vue&type=script&lang=js&"
import style0 from "./StartPlaying.vue?vue&type=style&index=0&id=1e3777c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3777c1",
  null
  
)

export default component.exports